//
// Initial state objects for the OIS Service Context/Providers
//

/**
 * To track the various loading states of API calls
 */
export const initLoading = {
  oisMetadata: false,
  oisData: false,
  eProtocolActivity: false,
  uploadEnvironments: false,
  uploadToOnCore: false,
  downloadData: false,
};

/**
 * To track the user selected search filters of the
 * OIS Table
 */
export const initOISSearchFilters = {
  action: null,
};

/**
 * To track the various options available to a user for
 * filtering the OIS Table search results
 */
export const initOISTableFilterOptions = {
  actions: [],
};

export const initUploadEnvironment = null;

/**
 * To track the various environments available to a user for
 * uploading data to OnCore
 */
export const initUploadEnvironments = {
  environments: [],
};
